import { IBAN_COUNTRIES } from './CountryConstants'

export const isIBANCountry = (countryCode: string): boolean => {
    return IBAN_COUNTRIES.includes(countryCode)
}
